// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { AppCleanup } from '../models';
import { Setting } from '../models/setting.model';

@Injectable({
	providedIn: 'root',
})
export class SettingsService extends AppCleanup {
	private settingUrl: string;

	constructor(private http: HttpClient) {
		super();
		this.settingUrl = `${this.apiUrl}api/setting`;
	}

	public getSettings() {
		return this.http.get<Setting[]>(this.settingUrl);
	}
}
